<div class="space-y-3.5">
  <!-- Info banner explaining purpose -->
  <div class="p-3.5 bg-primary-1 border border-primary-3 rounded-2xl flex items-start gap-3">
    <mat-icon class="!w-5 !h-5 !text-xl text-primary-9 shrink-0 mt-0.5">info</mat-icon>
    <div class="flex flex-col text-xs text-neutral-11 leading-relaxed">
      <span class="font-semibold text-primary-11">Coordonnées de contact direct</span>
      <span>
        Ces paramètres définissent comment vos clients peuvent vous joindre. Vous pouvez masquer un canal ou
        renseigner des coordonnées professionnelles dédiées.
      </span>
    </div>
  </div>

  <div class="grid grid-cols-1 gap-3">
    <!-- ==================== TÉLÉPHONE ==================== -->
    @if (!showPhone()) {
      <!-- Téléphone : ÉTAT MASQUÉ -->
      <div
        class="p-4 bg-neutral-1/60 dark:bg-neutral-3/30 rounded-2xl border border-dashed border-neutral-4 dark:border-neutral-5 flex items-center justify-between gap-3"
      >
        <div class="flex items-center gap-3 min-w-0">
          <div
            class="w-9 h-9 rounded-xl flex items-center justify-center shrink-0 bg-neutral-3 text-neutral-8 border border-neutral-4"
          >
            <mat-icon class="!w-4.5 !h-4.5 !text-lg">phone_disabled</mat-icon>
          </div>
          <div class="flex flex-col min-w-0">
            <span class="text-xs text-neutral-9 font-medium">Téléphone portable</span>
            <span class="text-xs italic text-neutral-9 flex items-center gap-1 mt-0.5">
              <mat-icon class="!w-3.5 !h-3.5 !text-xs text-neutral-8">visibility_off</mat-icon>
              Non diffusé sur votre profil public
            </span>
          </div>
        </div>
        <span
          class="text-[10px] font-bold px-2.5 py-1 rounded-full border shrink-0 bg-neutral-3 text-neutral-9 border-neutral-4 flex items-center gap-1.5"
        >
          <mat-icon class="!w-3.5 !h-3.5 !text-xs text-neutral-8">visibility_off</mat-icon>
          Masqué au public
        </span>
      </div>
    } @else if (hasCustomPhone()) {
      <!-- Téléphone : ÉTAT PERSONNALISÉ (PRO) -->
      <div
        class="p-4 bg-white dark:bg-neutral-2 rounded-2xl border-2 border-primary-5 shadow-xs flex items-center justify-between gap-3"
      >
        <div class="flex items-center gap-3 min-w-0">
          <div
            class="w-9 h-9 rounded-xl flex items-center justify-center shrink-0 bg-primary-2 text-primary-11 border border-primary-4"
          >
            <mat-icon class="!w-4.5 !h-4.5 !text-lg">call</mat-icon>
          </div>
          <div class="flex flex-col min-w-0">
            <span class="text-xs text-primary-11 font-semibold">Téléphone pro dédié</span>
            <span class="text-sm font-bold text-neutral-12 truncate">{{ phone() }}</span>
            <span class="text-[11px] text-primary-10 font-medium">Visible sur votre profil et annonces</span>
          </div>
        </div>
        <span
          class="text-[10px] font-bold px-2.5 py-1 rounded-full border shrink-0 bg-primary-2 text-primary-11 border-primary-5 flex items-center gap-1.5"
        >
          <mat-icon class="!w-3.5 !h-3.5 !text-xs text-primary-9">verified</mat-icon>
          Pro personnalisé
        </span>
      </div>
    } @else {
      <!-- Téléphone : ÉTAT PAR DÉFAUT (COMPTE) -->
      <div
        class="p-4 bg-white dark:bg-neutral-2 rounded-2xl border border-neutral-3 dark:border-neutral-4 shadow-xs flex items-center justify-between gap-3"
      >
        <div class="flex items-center gap-3 min-w-0">
          <div
            class="w-9 h-9 rounded-xl flex items-center justify-center shrink-0 bg-neutral-2 text-neutral-11 border border-neutral-3"
          >
            <mat-icon class="!w-4.5 !h-4.5 !text-lg">call</mat-icon>
          </div>
          <div class="flex flex-col min-w-0">
            <span class="text-xs text-neutral-10 font-medium">Téléphone portable</span>
            <span class="text-sm font-semibold text-neutral-12 truncate">
              {{ defaultPhone() || 'Numéro du compte personnel' }}
            </span>
            <span class="text-[11px] text-neutral-9">Hérité de votre compte utilisateur (visible)</span>
          </div>
        </div>
        <span
          class="text-[10px] font-bold px-2.5 py-1 rounded-full border shrink-0 bg-neutral-2 text-neutral-11 border-neutral-4 flex items-center gap-1.5"
        >
          <mat-icon class="!w-3.5 !h-3.5 !text-xs text-neutral-9">account_circle</mat-icon>
          Compte par défaut
        </span>
      </div>
    }

    <!-- ==================== EMAIL ==================== -->
    @if (!showEmail()) {
      <!-- Email : ÉTAT MASQUÉ -->
      <div
        class="p-4 bg-neutral-1/60 dark:bg-neutral-3/30 rounded-2xl border border-dashed border-neutral-4 dark:border-neutral-5 flex items-center justify-between gap-3"
      >
        <div class="flex items-center gap-3 min-w-0">
          <div
            class="w-9 h-9 rounded-xl flex items-center justify-center shrink-0 bg-neutral-3 text-neutral-8 border border-neutral-4"
          >
            <mat-icon class="!w-4.5 !h-4.5 !text-lg">mail_lock</mat-icon>
          </div>
          <div class="flex flex-col min-w-0">
            <span class="text-xs text-neutral-9 font-medium">Adresse email</span>
            <span class="text-xs italic text-neutral-9 flex items-center gap-1 mt-0.5">
              <mat-icon class="!w-3.5 !h-3.5 !text-xs text-neutral-8">visibility_off</mat-icon>
              Non diffusée sur votre profil public
            </span>
          </div>
        </div>
        <span
          class="text-[10px] font-bold px-2.5 py-1 rounded-full border shrink-0 bg-neutral-3 text-neutral-9 border-neutral-4 flex items-center gap-1.5"
        >
          <mat-icon class="!w-3.5 !h-3.5 !text-xs text-neutral-8">visibility_off</mat-icon>
          Masqué au public
        </span>
      </div>
    } @else if (hasCustomEmail()) {
      <!-- Email : ÉTAT PERSONNALISÉ (PRO) -->
      <div
        class="p-4 bg-white dark:bg-neutral-2 rounded-2xl border-2 border-primary-5 shadow-xs flex items-center justify-between gap-3"
      >
        <div class="flex items-center gap-3 min-w-0">
          <div
            class="w-9 h-9 rounded-xl flex items-center justify-center shrink-0 bg-primary-2 text-primary-11 border border-primary-4"
          >
            <mat-icon class="!w-4.5 !h-4.5 !text-lg">alternate_email</mat-icon>
          </div>
          <div class="flex flex-col min-w-0">
            <span class="text-xs text-primary-11 font-semibold">Email pro dédié</span>
            <span class="text-sm font-bold text-neutral-12 truncate">{{ email() }}</span>
            <span class="text-[11px] text-primary-10 font-medium">Visible sur votre profil et annonces</span>
          </div>
        </div>
        <span
          class="text-[10px] font-bold px-2.5 py-1 rounded-full border shrink-0 bg-primary-2 text-primary-11 border-primary-5 flex items-center gap-1.5"
        >
          <mat-icon class="!w-3.5 !h-3.5 !text-xs text-primary-9">verified</mat-icon>
          Pro personnalisé
        </span>
      </div>
    } @else {
      <!-- Email : ÉTAT PAR DÉFAUT (COMPTE) -->
      <div
        class="p-4 bg-white dark:bg-neutral-2 rounded-2xl border border-neutral-3 dark:border-neutral-4 shadow-xs flex items-center justify-between gap-3"
      >
        <div class="flex items-center gap-3 min-w-0">
          <div
            class="w-9 h-9 rounded-xl flex items-center justify-center shrink-0 bg-neutral-2 text-neutral-11 border border-neutral-3"
          >
            <mat-icon class="!w-4.5 !h-4.5 !text-lg">alternate_email</mat-icon>
          </div>
          <div class="flex flex-col min-w-0">
            <span class="text-xs text-neutral-10 font-medium">Adresse email</span>
            <span class="text-sm font-semibold text-neutral-12 truncate">
              {{ defaultEmail() || 'Email du compte personnel' }}
            </span>
            <span class="text-[11px] text-neutral-9">Hérité de votre compte utilisateur (visible)</span>
          </div>
        </div>
        <span
          class="text-[10px] font-bold px-2.5 py-1 rounded-full border shrink-0 bg-neutral-2 text-neutral-11 border-neutral-4 flex items-center gap-1.5"
        >
          <mat-icon class="!w-3.5 !h-3.5 !text-xs text-neutral-9">account_circle</mat-icon>
          Compte par défaut
        </span>
      </div>
    }
  </div>
</div>
